import React, { PureComponent } from "react";
import { view } from "@risingstack/react-easy-state";
import Styled from "components/decisions/style";
import PostedDecisions from "./assets/posted-decisions.jpg";
import DecisionsWaitForSales from "./assets/decisions-wait-for-sales.png";


class Decisions extends PureComponent {
  render() {
    return (
      <Styled.BodyWrapper>
        <Styled.Title>
          The Decision & Sales Process
        </Styled.Title>

        <Styled.Paragraph>Make Cross-functional Decisions&nbsp;&nbsp;--&gt;&nbsp;&nbsp;Post Them&nbsp;&nbsp;--&gt;&nbsp;&nbsp;And Then Wait for the Sales Process</Styled.Paragraph>

        <Styled.Steps>
          <Styled.Step className="blue">
            <Styled.StepTitle>Step 1: Make Decisions</Styled.StepTitle>
            <Styled.StepParagraph>We recommend making decisions in the following order:</Styled.StepParagraph>
            <Styled.StepOrderItems>
              <Styled.StepOrderItem><b>PRODUCT:</b> Create an image sensor that customers want. You can create up to 4 sensors.</Styled.StepOrderItem>
              <Styled.StepOrderItem><b>MARKETING:</b> make pricing, promotion, and sales decisions for your product(s).</Styled.StepOrderItem>
              <Styled.StepOrderItem><b>OPERATIONS:</b> Make manufacturing decisions for your product(s).</Styled.StepOrderItem>
              <Styled.StepOrderItem><b>CEO PROJECTIONS:</b> Make financial projections for investors.</Styled.StepOrderItem>
              <Styled.StepOrderItem><b>FINANCE:</b> Raise capital from investors to finance your product, marketing, and operation spending.</Styled.StepOrderItem>
            </Styled.StepOrderItems>
          </Styled.Step>
          <Styled.Step className="ivory">
            <Styled.StepTitle>Step 2: Post Decisions</Styled.StepTitle>
            <Styled.StepParagraph>After making all decisions, navigate to the CEO page and post them, <u>start with posting finance</u>.</Styled.StepParagraph>
            <Styled.StepParagraph><b>Note:</b> Your cash balance needs to be positive before you can post successfully.</Styled.StepParagraph>
            <Styled.Gap />
            <Styled.StepParagraph className="small">Example: Successfully posted decisions</Styled.StepParagraph>
            <Styled.Image src={PostedDecisions} alt="Posted Decisions" />
          </Styled.Step>
          <Styled.Step className="white">
            <Styled.StepTitle>Step 3: Wait for sales</Styled.StepTitle>
            <Styled.StepParagraph>Your work is done after posting your decisions, Just wait for the round deadline to end for sales to process.</Styled.StepParagraph>
            <Styled.StepParagraph className="no-margin">Here’s how the sales process works:</Styled.StepParagraph>
            <Styled.List>
              <Styled.ListItem><b>Awareness:</b> Customer search and discover the most visible products.</Styled.ListItem>
              <Styled.ListItem><b>Consideration:</b> They compare options that fit their preferences.</Styled.ListItem>
              <Styled.ListItem><b>Conversion:</b> They then buy the product that fits the preferences best.</Styled.ListItem>
            </Styled.List>
            <Styled.Image src={DecisionsWaitForSales} alt="Decisions Wait For Sales" />
            <Styled.StepParagraph className="no-margin"><b>Tip:</b> Sales depend on your product’s visibility and attractiveness to customers.</Styled.StepParagraph>
          </Styled.Step>
        </Styled.Steps>
      </Styled.BodyWrapper>
    );
  }
}

export default view(Decisions);



// WEBPACK FOOTER //
// ./src/containers/decisions.js